module.exports = __webpack_public_path__ + "img/32.943e76b.webp";